import styled, {css} from 'styled-components'

const Style = {
	Btn: styled.button`
		width: 100%;
		height: fit-content;
		display: flex;
		justify-content: space-between;
		align-items: center;
		gap: 8px;
		padding: 10px 8px;
		background: linear-gradient(135deg, #0078d4 0%, #106ebe 100%);
		color: white;
		font-weight: 600;
		font-size: 14px;
		border-radius: 12px;
		border: none;
		cursor: pointer;
		position: relative;
		overflow: hidden;
		box-shadow: 0 4px 12px rgba(0, 120, 212, 0.3);
		transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

		/* Glow effect */
		&::before {
			content: '';
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			background: linear-gradient(135deg, #0078d4 0%, #106ebe 100%);
			border-radius: 12px;
			opacity: 0;
			transition: opacity 0.3s ease;
			z-index: -1;
		}

		&:hover {
			transform: translateY(-2px);
			box-shadow: 0 8px 25px rgba(0, 120, 212, 0.4);
			background: linear-gradient(135deg, #106ebe 0%, #0078d4 100%);

			&::before {
				opacity: 1;
				background: linear-gradient(135deg, #106ebe 0%, #0078d4 100%);
			}
		}

		&:active {
			transform: translateY(-1px);
			box-shadow: 0 4px 15px rgba(0, 120, 212, 0.3);
		}

		&:disabled {
			background: linear-gradient(135deg, #6c757d 0%, #5a6268 100%);
			cursor: not-allowed;
			transform: none;
			box-shadow: 0 2px 8px rgba(108, 117, 125, 0.2);

			&::before {
				opacity: 0;
			}
		}

		img {
			width: 20px;
			height: 20px;
			filter: brightness(0) invert(1);
		}

		div {
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			flex: 1;
		}

		${({$small}) =>
			$small &&
			css`
				font-size: 14px;
				padding: 12px 20px;
				gap: 10px;
				border-radius: 10px;

				img {
					width: 18px;
					height: 18px;
				}
			`}

		${({$fitWidth}) =>
			$fitWidth &&
			css`
				width: fit-content;
				min-width: 200px;
			`}

		${({$downloading}) =>
			$downloading &&
			css`
				background: linear-gradient(135deg, #6c757d 0%, #5a6268 100%);
				cursor: not-allowed;
				transform: none;
				box-shadow: 0 2px 8px rgba(108, 117, 125, 0.2);

				&::before {
					opacity: 0;
				}
			`}
	`,
}

export default Style
